const crop_data_v2 = {
  title: `Crop/Agricultural Activity Profiles`,
  body: `Select the Crop/Agricultural Activity profile(s) to populate in the Addendum A table.`,
  table: {
    th: ["Crop ID", "Crop and/or Agricultural Activity"],
    td: ["crop_id", "crop_agricultural_activity"],
  },
  new_profile(profile) {
    return {
      id: profile.id,
      crop_id: profile.crop_id,
      crop_agricultural_activity: profile.crop_agricultural_activity,
      crop_wage_offer: null,
      crop_per: null,
      crop_piece_rate: null,
    };
  },
};

export default crop_data_v2;
